import { Button, Popover } from '@lithos';
import { FC, useState } from 'react';
import { useUserSettings } from '../../context/UserSettingsContext';
import TectonWorkspaceSelector from '../../@tecton/SideNavigation/TectonWorkspaceSelector';
import { getSideNavigationWorkspaces } from '../util';

interface RealtimeMonitoringWorkspaceSelectorProps {
  onWorkspaceSelected: (workspace?: string) => void;
  selectedWorkspace?: string;
}

const RealtimeMonitoringWorkspaceSelector: FC<RealtimeMonitoringWorkspaceSelectorProps> = ({
  onWorkspaceSelected,
  selectedWorkspace,
}) => {
  const { allWorkspaces } = useUserSettings();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const foundSelectedWorkspace = allWorkspaces?.find((ws) => {
    return ws.name === selectedWorkspace;
  });

  const workspaces = getSideNavigationWorkspaces(
    allWorkspaces?.filter((ws) => {
      return ws.workspaceType === 'Live';
    }) ?? []
  );

  return (
    <Popover
      placement="bottom"
      data-testid="feature-service-group-selector"
      trigger={
        <Button
          label="Workspace"
          type="secondary"
          iconLeft={foundSelectedWorkspace?.workspaceType === 'Live' ? 'ProductionWorkspace' : 'DevelopmentWorkspace'}
          iconRight="ChevronDown"
        />
      }
      maxWidth={400}
      isOpen={isOpen}
      body={
        <TectonWorkspaceSelector
          workspaces={workspaces}
          onWorkspaceSelected={(ws) => {
            setIsOpen(false);
            onWorkspaceSelected(ws.name);
          }}
          hideDevelopmentSection={true}
        />
      }
      setIsOpen={() => {
        setIsOpen(!isOpen);
      }}
    />
  );
};

export default RealtimeMonitoringWorkspaceSelector;
